module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/sample2-sp-5a8f3198ff5155896ea71d48c8a8e02c.jpg";